import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import lottie from "lottie-web";
import Typical from "react-typical";
import Fade from "react-reveal/Fade";

const About = () => {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../../../animation/programming-animation.json"),
    });
  }, [container]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className="py-4 my-5">
      <Fade bottom>
        <p className="text-white text-center fw-bold fs-1">About Me</p>
        <Row>
          <Col xs={12} sm={12} md={12} lg={7}>
            <div className="container pt-0" ref={container}></div>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={5}
            className="d-flex  flex-column align-items-center justify-content-center"
          >
            <div style={{ textAlign: "justify" }}>
              <p className="fs-4 pt-4 mt-3 text-center">
                I am{" "}
                <Typical
                  steps={[
                    "Md Ahanaf Tahmid Islam",
                    2000,
                    "a junior front-end software developer",
                    2000,
                    "a front-end web developer",
                    2000,
                    "a programmer",
                    2000,
                  ]}
                  loop={Infinity}
                  wrapper="b"
                />
              </p>
              <p>
                A frontend 𝘀𝗼𝗳𝘁𝘄𝗮𝗿𝗲 𝗱𝗲𝘃𝗲𝗹𝗼𝗽𝗲𝗿 with experience in building
                websites and web applications. I specialize in 𝗝𝗮𝘃𝗮𝘀𝗰𝗿𝗶𝗽𝘁 and
                have experience working with 𝗥𝗲𝗮𝗰𝘁.𝗷𝘀, 𝗧𝗮𝗶𝗹𝘄𝗶𝗻𝗱, 𝗕𝗼𝗼𝘁𝘀𝘁𝗿𝗮𝗽𝟱,
                𝗠𝗮𝘁𝗲𝗿𝗶𝗮𝗹 𝗨𝗜, 𝗘𝘅𝗽𝗿𝗲𝘀𝘀.𝗷𝘀, 𝗡𝗼𝗱𝗲.𝗷𝘀, 𝗙𝗶𝗿𝗲𝗯𝗮𝘀𝗲, 𝗮𝗻𝗱 𝗼𝘁𝗵𝗲𝗿 𝗳𝗿𝗼𝗻𝘁𝗲𝗻𝗱 &
                𝗯𝗮𝗰𝗸𝗲𝗻𝗱 𝘁𝗲𝗰𝗵𝗻𝗼𝗹𝗼𝗴𝗶𝗲𝘀, which I use for my web development
                purposes. I preferred to work with the 𝗠𝗘𝗥𝗡 𝗦𝘁𝗮𝗰𝗸. I love to
                work as a professional 𝘀𝗼𝗳𝘁𝘄𝗮𝗿𝗲 𝗱𝗲𝘃𝗲𝗹𝗼𝗽𝗲𝗿 to gain efficient
                knowledge of existing ideas and work as part of a varied team
                contributing to my personal and professional development.
                Finally, I want to add my experience in the software development
                industry. Could you take a look at my work or get in touch? For
                any queries, please email me at: tahmid231@gmail.com.
              </p>
            </div>
          </Col>
        </Row>
      </Fade>
    </Container>
  );
};

export default About;
